<template>
  <slot :display-items="displayItems" />

  <div
    v-if="!isExpanded && items.length > limit"
    class="mt-5 flex justify-center"
  >
    <UButton
      class="px-5 typo-paragraph-md-medium! ring-button-foreground gap-3"
      variant="outline"
      icon="i-local-ellipsis"
      @click="onShowAll"
    >
      Посмотреть все
    </UButton>
  </div>
</template>

<script setup lang="ts" generic="T">
defineOptions({
  name: 'ExpandableList',
})

const props = withDefaults(
  defineProps<{
    items?: T[]
    limit?: number
  }>(),
  {
    items: () => [],
    limit: 9,
  },
)

const isExpanded = ref(false)

const displayItems = computed<T[]>(() =>
  isExpanded.value ? props.items : props.items.slice(0, props.limit),
)

function onShowAll() {
  isExpanded.value = true
}
</script>
